/** Einräum-Packliste (Mieterportal 2.0): neue Artikel zum Abhaken beim Einräumen im Laden; danach gelten sie als eingeräumt. */
import { useTx } from "../i18n";
import { useState } from "react";
import { Link } from "react-router";
import { Button, EmptyState, Icon, Notice, Seitenzustand } from "../ui";
import { ItemRow } from "../ui/ItemRow";
import { ApiFehler } from "../api/client";
import { formatEuro } from "@shared/geld";
import { fotoUrl, useMeineArtikel } from "./artikel-api";
import { useEingeraeumt } from "./cockpit-api";

export function Packliste() {
  const tx = useTx();
  const q = useMeineArtikel(undefined, undefined, "packliste");
  const melden = useEingeraeumt();
  const [haken, setHaken] = useState<Set<string>>(new Set());
  const [meldung, setMeldung] = useState<string | null>(null);
  const liste = q.data?.artikel ?? [];
  const toggle = (id: string) => setHaken((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  const summe = liste.reduce((a, x) => a + x.preisCent, 0);

  return (
    <div className="sc-col" style={{ gap: "var(--space-3)" }}>
      <div className="sc-row">
        <Link to="/mieter" className="rg-btn rg-btn--quiet" aria-label="Zurück">‹</Link>
        <h1 className="title">{tx("Einräumen")}</h1>
      </div>
      {meldung ? <Notice tone="success" icon="sparkles">{meldung}</Notice> : null}
      <Seitenzustand query={q} lines={4} thumb istLeer={(d) => d.artikel.length === 0} leer={<EmptyState illustration="all-done" title={tx("Alles eingeräumt")} action={<Link to="/mieter/erfassen" className="rg-btn rg-btn--primary">Neue Artikel erfassen</Link>}>Nichts wartet auf den Weg ins Regal.</EmptyState>}>
        {() => (
          <>
            <p className="sc-muted">{liste.length} {liste.length === 1 ? "Artikel wartet" : "Artikel warten"} · {formatEuro(summe)} · {haken.size} von {liste.length} abgehakt</p>
            <div className="sc-progress" aria-hidden="true"><span style={{ width: `${liste.length ? (haken.size / liste.length) * 100 : 0}%` }} /></div>
            <div>
              {liste.map((a) => (
                <ItemRow key={a.id} title={a.bezeichnung} photo={fotoUrl(a.fotoKey)} meta={`${a.code} · ${formatEuro(a.preisCent)}${a.etikettGedrucktAt ? "" : " · Etikett fehlt"}`} selected={haken.has(a.id)} onClick={() => toggle(a.id)} action={<span className="mp-kachel-artikel__check" style={{ position: "static" }} aria-hidden="true">{haken.has(a.id) ? <Icon name="check" size={16} /> : null}</span>} />
              ))}
            </div>
            <div className="mp-foot">
              <Button variant="primary" size="lg" block icon="circle-check" loading={melden.isPending} disabled={haken.size === 0} onClick={() => melden.mutate([...haken], { onSuccess: (r) => { setMeldung(`${r.gemeldet} Artikel stehen jetzt im Regal – viel Erfolg.`); setHaken(new Set()); }, onError: (e) => setMeldung(e instanceof ApiFehler ? e.message : "Das hat nicht geklappt.") })}>
                {haken.size === liste.length ? `Alle ${liste.length} als eingeräumt melden` : `${haken.size} als eingeräumt melden`}
              </Button>
              {haken.size < liste.length ? <Button variant="quiet" block onClick={() => setHaken(new Set(liste.map((a) => a.id)))}>Alle abhaken</Button> : null}
            </div>
          </>
        )}
      </Seitenzustand>
    </div>
  );
}
